export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950 text-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg font-heading">
                51
              </span>
              <span className="text-xl font-bold text-background-50 font-heading tracking-tight">
                爆料
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              51爆料网是全网领先的爆料资讯聚合平台，致力于为用户提供真实、快速、全面的爆料内容浏览体验。
              全天候更新，多领域覆盖，是您获取最新爆料资讯的首选入口。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '热门爆料', href: '#cards' },
                { label: '最新快讯', href: '#updates' },
                { label: '热度榜单', href: '#ranking' },
                { label: '视频爆料', href: '#media' },
                { label: '投稿爆料', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="space-y-2.5">
              {['社会热点', '科技行业', '金融动态', '娱乐圈爆料', '互联网圈', '消费维权'].map((cat) => (
                <a
                  key={cat}
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              平台持续拓展合作资源，更多合作伙伴即将入驻。如有合作意向，欢迎通过投稿通道联系我们。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 51爆料网 51baoliao.com 版权所有 | 本站内容仅供信息参考，不构成任何建议
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span>隐私政策</span>
            <span>用户协议</span>
            <span>免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}